import type { SVGProps } from "react";

export function IconWhitePieSlash(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M29 53.995L28.985 54.7449L29.75 54.7602V53.995H29ZM29 29V28.25H28.25V29H29ZM53.995 29V29.75H54.7602L54.7449 28.985L53.995 29ZM29.75 53.995V29H28.25V53.995H29.75ZM29 29.75H53.995V28.25H29V29.75ZM29.5 5.75C42.4547 5.75 52.9871 16.1223 53.2451 29.015L54.7449 28.985C54.4704 15.2774 43.2731 4.25 29.5 4.25V5.75ZM5.75 29.5C5.75 16.3832 16.3832 5.75 29.5 5.75V4.25C15.5548 4.25 4.25 15.5548 4.25 29.5H5.75ZM29.015 53.2451C16.1223 52.9871 5.75 42.4547 5.75 29.5H4.25C4.25 43.2731 15.2774 54.4704 28.985 54.7449L29.015 53.2451Z"
        fill="#23232C"
      />
      <path
        d="M58 8L8 58"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M59 34.4661H58.25L59.75 34.4651L59 34.4661ZM59 34.5338L59.75 34.5348L58.25 34.5338H59ZM36.8535 58.8883L36.9247 59.635L36.1035 59.7132V58.8883H36.8535ZM58.874 36.9999V36.2499H59.7039L59.6202 37.0756L58.874 36.9999ZM36.8535 36.9999H36.1035V36.2499H36.8535V36.9999ZM58.25 34.4999C58.25 34.489 58.25 34.478 58.25 34.4671L59.75 34.4651C59.75 34.4767 59.75 34.4883 59.75 34.4999H58.25ZM58.25 34.5328C58.25 34.5218 58.25 34.5109 58.25 34.4999H59.75C59.75 34.5115 59.75 34.5232 59.75 34.5348L58.25 34.5328ZM58.25 34.5338V34.4661H59.75V34.5338H58.25ZM36.7823 58.1417C48.0293 57.0698 56.9899 48.1519 58.1278 36.9243L59.6202 37.0756C58.4101 49.0149 48.8846 58.4951 36.9247 59.635L36.7823 58.1417ZM36.1035 58.8883V36.9999H37.6035V58.8883H36.1035ZM36.8535 36.2499H58.874V37.7499H36.8535V36.2499Z"
        fill="#23232C"
      />
    </svg>
  );
}
